import discount from "./discount";
import district from "./district";
import promotion from "./promotion";


export default {discount, district, promotion};
